import { render } from "./Super.vue?vue&type=template&id=e7e80dce"
import script from "./Super.vue?vue&type=script&lang=js"
export * from "./Super.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__